/* Vegan LifeMoss Subscribe & Save page: frequency picker + subscribe add-to-cart. */
(function () {
  'use strict';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  function fmt(c) { return '$' + (Math.round(c) / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function init(card) {
    if (card.__sp) return; card.__sp = true;
    var price = card.querySelector('[data-sp-price]');
    var radios = card.querySelectorAll('input[type="radio"]');
    radios.forEach(function (r) {
      r.addEventListener('change', function () { if (r.checked && price) price.textContent = fmt(+r.getAttribute('data-sub-price')); });
    });
    var btn = card.querySelector('[data-sp-add]');
    if (!btn) return;
    var label = btn.innerHTML;
    btn.addEventListener('click', function () {
      var sel = card.querySelector('input[type="radio"]:checked');
      var item = { id: +card.getAttribute('data-variant'), quantity: 1 };
      if (sel) item.selling_plan = +sel.value;
      btn.disabled = true; btn.textContent = 'Adding…';
      fetch(root + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [item] }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function () {
          btn.disabled = false; btn.textContent = 'Added ✓';
          setTimeout(function () { btn.innerHTML = label; }, 2200);
          try { if (window.upcartRefreshCart) window.upcartRefreshCart(); if (window.upcartOpenCart) { window.upcartOpenCart(); return; } } catch (e) {}
          window.location.href = root + 'cart';
        })
        .catch(function (err) {
          btn.disabled = false; btn.innerHTML = label;
          var n = card.querySelector('.vh-sp__err') || document.createElement('p');
          n.className = 'vh-sp__err'; n.setAttribute('role', 'alert');
          n.textContent = (err && (err.description || err.message)) || 'Sorry, that could not be added.';
          card.querySelector('.vh-sp__body').appendChild(n);
        });
    });
  }
  function boot() { document.querySelectorAll('[data-sp-card]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
